"use client";

import Script from "next/script";
import { useEffect } from "react";

const GA_TRACKING_ID = "G-81H299KNCV";

type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

export function GoogleAnalytics() {
  // Сквозная аналитика CTA: один делегированный слушатель ловит клики по
  // [data-cta-location] и отправляет событие в GA, не превращая страницы
  // и PageHero в клиентские компоненты.
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target as Element | null;
      const element = target?.closest?.("[data-cta-location]");
      if (!element) return;
      const gtag = (window as GtagWindow).gtag;
      if (typeof gtag !== "function") return;
      gtag("event", "cta_click", {
        cta_location: element.getAttribute("data-cta-location"),
      });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
        strategy="lazyOnload"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_TRACKING_ID}');
        `}
      </Script>
    </>
  );
}
